import styled, { css } from 'styled-components';

import { ButtonText, PrimaryButton } from '@prisjakt/ui/button/variants';
import { Card, CardBackgroundImage } from '@prisjakt/ui/card';
import { media, layout } from 'src/components/base';
import RichText from 'src/areas/editorial-content/components/slices/rich-text';
import { FontWeight } from '@prisjakt/ui/text/variants';

/* stylelint-disable no-duplicate-selectors */
// Disabled due to https://styled-components.com/docs/faqs#how-can-i-override-styles-with-higher-specificity

type ButtonTextProps = {
  fontColor: string;
};

export const Title = styled(RichText)`
  & > h1 {
    margin-bottom: 0;
    text-align: center;
  }
`;

export const SubTitle = styled.p`
  max-width: 440px;
  font-size: ${layout.measurements.fontSizeLarge};
  line-height: 24px;
  text-align: center;
  ${media.smallOnly`
    max-width: 304px;
  `};
`;

export const Button = styled(PrimaryButton)`
  max-width: 304px;
  width: 100%;
`;

export const Banner = styled(Card)`
  max-width: 980px;
  ${media.smallOnly`
    width: 100%;
    max-height: 236px;
    margin: auto;
    margin-bottom: ${layout.measurements.spacing200};
  `};
`;

export const TextButton = styled(ButtonText)<ButtonTextProps>(
  props => css`
    text-align: center;
    font-weight: ${FontWeight.HEAVIER};
    font-size: ${layout.measurements.fontSizeNormal};
    color: ${props.fontColor};
  `
);

export const BackgroundImage = styled(CardBackgroundImage)`
  & {
    background-color: transparent;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${layout.measurements.spacing200} ${layout.measurements.spacing100};
`;
